import { FC } from "react";
import { Stack } from "capitalrx-components-2.0/lib/layout";
import { BenefitSearch } from "@/components";
import styles from "./MedicalBenefitSearchPage.module.scss";


export const MedicalBenefitSearchPage: FC = () => {


  return (
    <div className={styles.MedicalPanelContainer}>
      <Stack spacing="large">
        <BenefitSearch />
      </Stack>
    </div>
  );
};

export default MedicalBenefitSearchPage;
